<template>
  <v-card class="mb-4 pa-4">
    <v-card-title class="text-h6 darken--text pa-0 mb-8 align-start">
      <div class="wrap-text underlined-hover">
        <router-link
          :to="{ name: 'project-single', params: { id: project.id } }"
          target="_blank"
        >
          {{ project.name }}
        </router-link>
      </div>
      <div>
        <v-btn
          class="nav-button"
          outlined
          :disabled="projectsCount < 2"
          @click="$emit('changeProject', { dir: 'prev' })"
        >
          <v-icon>mdi-chevron-left</v-icon> Poprzedni projekt
        </v-btn>
        <v-btn
          class="nav-button ml-2"
          outlined
          :disabled="projectsCount < 2"
          @click="$emit('changeProject', { dir: 'next' })"
        >
          Następny projekt<v-icon>mdi-chevron-right</v-icon>
        </v-btn>
      </div>
    </v-card-title>
    <v-card-text class="pa-0">
      <v-row>
        <v-col
          v-if="project.files.length"
          cols="12"
          lg="6"
        >
          <ProjectFilesCarousel :files="project.files" />
        </v-col>
        <v-col>
          <AcceptanceFilesList
            v-model="selectedFiles"
            :all-files="project.files"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col
          cols="12"
          class="pb-0"
        >
          <AcceptanceActions
            :project="project"
            :selected-files="selectedFiles"
          />
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import ProjectFilesCarousel from '@/components/Projects/Acceptance/ProjectFilesCarousel.vue';
import AcceptanceFilesList from '@/components/Projects/Acceptance/AcceptanceFilesList.vue';
import AcceptanceActions from '@/components/Projects/Acceptance/AcceptanceActions.vue';

export default {
  props: {
    project: {
      type: Object,
      required: true,
    },
    projectsCount: {
      type: Number,
      required: true,
    },
  },
  components: {
    ProjectFilesCarousel,
    AcceptanceFilesList,
    AcceptanceActions,
  },
  data: () => ({
    selectedFiles: [],
  }),
  mounted() {
    if (this.project.files.length === 1) {
      const fileId = [...this.project.files].pop().id;
      this.selectedFiles = [fileId];
    }
  },
};
</script>

<style lang="scss" scoped>
.acceptance-avatar {
  width: 32px;
  height: 32px;
}
.wrap-text {
  word-break: normal;
  width: calc(100% - 380px);
}
</style>
